import { forwardRef, Ref, type SVGProps } from 'react';

const SvgQuoteMarkIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    overflow="visible"
    preserveAspectRatio="none"
    style={{
      display: 'block',
    }}
    viewBox="0 0 39 32"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M0 32v-6.535q.112-3.269.225-5.972.225-9.69 3.034-14.535Q6.07 0 13.824 0l1.349 5.746q-4.384.114-5.62 2.93t-1.236 7.211h7.755V32zm22.928 0v-6.535q.112-3.269.225-5.972.225-9.69 3.034-14.535Q28.997 0 36.752 0l1.349 5.746q-4.383.114-5.62 2.93-1.236 2.817-1.236 7.211H39V32z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgQuoteMarkIcon);
export default ForwardRef;
